import React from 'react';
import ReactDOM from 'react-dom';
import ChatApp from './base/ChatApp';

ReactDOM.render(
  <React.StrictMode>
    <ChatApp></ChatApp>
  </React.StrictMode>,
  document.getElementById('root')
);
